export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "fetch.worker.f0e20c67993884e98214.worker.js");
}
